import React, { createContext, FC, ReactNode } from 'react'

interface Props {
  children: ReactNode
  isPreview: boolean
}

// The preview context is used to show or hide the "Edit" button conditionally for images,
// galleries, videos, and custom embeds in the clipboard items and related items menus.
export const PreviewContext = createContext<{ isPreview: boolean }>({
  isPreview: false,
})

export const PreviewContextProvider: FC<Props> = ({
  children,
  isPreview = false,
}) => {
  return (
    <PreviewContext.Provider value={{ isPreview }}>
      {children}
    </PreviewContext.Provider>
  )
}
